import axios from 'axios'
import { baseApiUrl, showError, showSuccess, userKey } from "@/global";
const sucess = res => res
const error = err => {
    if (401 === err.response.status) {
        showError({
            response: {
                data: {
                    userMessage: "Sessão expirada",
                },
            },
        });
        const user = JSON.parse(sessionStorage.getItem("loginPassword"));
        axios
            .post(`${baseApiUrl}/api/autenticacao`, user)
            .then((res) => {
                sessionStorage.setItem(userKey, JSON.stringify(res.data));
                axios.defaults.headers.common['Authorization'] = `${res.data.tokenType} ${res.data.token}`;
                showSuccess({
                    response: {
                        data: {
                            userMessage: "Sessão atualizada, refaça a operação",
                        },
                    },
                })
            })
            .catch((res) => showError(res));
        // sessionStorage.setItem('sessionExpired', JSON.stringify(err));
        // window.location = '/'
    } else {
        return Promise.reject(err)
    }
}

axios.interceptors.response.use(sucess, error)